export function downloadFile(filePath: string, fileName?: string): void {
    const link = document.createElement('a');
    link.href = filePath;
    if (fileName) {
        link.setAttribute('download', fileName);
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function downloadBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    downloadFile(url, fileName);
    URL.revokeObjectURL(url);
}
